import {Antenna} from "../entities/Antenna";
import {BaseService} from "./BaseService";
import { StateService } from "@uirouter/angularjs";

export class AntennaService extends BaseService<Antenna>{
    static $inject = ['$http','$q','$state'];
    constructor($http: ng.IHttpService, $q: ng.IQService, $state: StateService) {
        super($http, $q, $state, Antenna);
    }
    protected getBaseUrl():string{
        return "antenna";
    }
    GetByReader(readerId:number):ng.IPromise<Antenna[]>{
        var config:any = {};
        return this.useBaseGetArrayHandler(this.getBasesUrl(),"reader/"+readerId, config);
    }
    InsertByReader(readerId:number, antennas:Antenna[]):ng.IPromise<void>{
        var config:any = {};
        return this.usePostHandler(this.getBasesUrl(),"reader/"+readerId, antennas, config);
    }
}
